import React from "react";

import { flexRender, Table, Column, Header } from "@tanstack/react-table";

/**
 * Columns whose rendered header carries extras (info tooltips, icons) provide
 * a plain `meta.plainLabel` to name the column outside the table head — in
 * the filter bar and the adjust-view list.
 */
interface ColumnWithPlainLabel {
    columnDef: {
        meta?: {
            plainLabel?: string;
        };
    };
}

export function columnPlainLabel<T>(
    col: Column<T> & ColumnWithPlainLabel,
    table: Table<T>
): React.ReactNode {
    return (
        col.columnDef.meta?.plainLabel ??
        // Render the header outside a real header context:
        // https://github.com/TanStack/table/discussions/4857
        flexRender(col.columnDef.header, {
            table,
            column: col,
            header: { column: col } as Header<T, unknown>,
        })
    );
}
